import React, { useState } from 'react'
import date from 'date-and-time'
import useTime from '../../../../../../../Helpers/CustomHooks/useTime'
import { getBatchLayoutData } from '../../../../../../Dashboard/Components/Courses/Components/GroupCourseBatches/Helper'
import { BatchEl } from '../Elements'
import { H4, H5, Text } from '../../../../../../../Styles/typography'
import Button from '../../../../../../../Components/Buttons/Button'
import GroupRegistrationStore from '../Store/GroupRegistrationStore'
import { getBatchSchedule } from '../../../../../Helpers/Timings'

function Batch({
  batch: {
    id,
    title,
    dateSlots: slots,
    classes,
    canJoin = true,
    registrationCount,
    batchLimit,
  },
  index,
  withAction = true,
  onSubmit = () => {},
}) {
  const now = useTime(5000)
  const [{ days }] = useState(getBatchLayoutData(slots))
  const [loading, setLoading] = useState(false)
  const { setSelBatch } = GroupRegistrationStore.useContainer()

  const startTime = slots.sort((a, b) => a.startTime - b.startTime)[0].startTime
  const endTime = slots.sort((a, b) => a.startTime - b.startTime).slice(-1)[0]
    .endTime
  const duration = (slots[0].endTime - slots[0].startTime) / (1000 * 60 * 60)
  const schedule = getBatchSchedule(slots)

  return endTime < now ? null : (
    <BatchEl isActive={canJoin}>
      <div className='info'>
        <H4 bold>{title}</H4>
        <Text>
          {Object.keys(classes).length} classes ({duration}{' '}
          {duration > 1 ? 'hours each' : 'hour each'})
        </Text>
        <H5 bold>Timeline:</H5>
        <Text className='timeline-info'>
          First Class on{' '}
          <span>
            {date
              .format(new Date(startTime), `DD MMMM YYYY, ddd`)
              .split('.')
              .join('')}{' '}
          </span>
        </Text>
        <Text className='timeline-info'>
          Last class on{' '}
          <span>
            {date
              .format(new Date(endTime), `DD MMMM YYYY, ddd`)
              .split('.')
              .join('')}{' '}
          </span>
        </Text>
        <H5 bold>Weekly Classes ({days.length}):</H5>
        {schedule.map((timing) => (
          <Text key={timing}>
            {timing}{' '}
            {new Date()
              .toLocaleTimeString('en-us', { timeZoneName: 'long' })
              .split(' ')
              .slice(2)
              .map((word) => word.charAt(0))
              .join('')}
          </Text>
        ))}
        {withAction && canJoin && batchLimit - registrationCount <= 2 && (
          <p className='fomo'>
            {batchLimit - registrationCount} seats remaining
          </p>
        )}
        {withAction && (
          <div className='actions'>
            <Button
              onClick={async () => {
                if (canJoin) {
                  setLoading(true)
                  setSelBatch(index)
                  await onSubmit(id)
                  setLoading(false)
                }
              }}
              name={canJoin ? 'Select' : 'Batch Full'}
              type={'primary'}
              disabled={!canJoin || loading || now >= endTime}
              loading={loading}
            />
          </div>
        )}
      </div>
    </BatchEl>
  )
}

export default Batch
